import React from 'react';



interface CustomCheckInputProperties {
  inputLabel?: string;
  checkboxLabel: string;
  value: boolean;
  name: string;
  onChangeValue: (name: string, value: boolean) => void;
  valueRequired?: boolean;
  error?: boolean;
  errorMessage?: string;
  fontSize?: 'small' | 'medium' | 'large';
}

/**
 * Check box buttons function component
 * @param {CustomCheckInputProperties} properties - The component properties
 * @param {string} [properties.inputLabel] - The inputLabel prop
 * @param {string} properties.checkboxLabel - The checkboxLabel prop
 * @param {string} properties.name - The name prop
 * @param {boolean} properties.value - The value prop
 * @param {(name: string, value: boolean) => void} properties.onChangeValue - The onChangeValue prop
 * @param {boolean} [properties.valueRequired] - The valueRequired prop
 * @param {boolean} [properties.error] - The error prop
 * @param {string} [properties.errorMessage] - The errorMessage prop
 * @param {'small' | 'medium' | 'large'} [properties.fontSize] - The fontSize prop
 * @returns {React.JSX.Element} The rendered custom checkbox component
 */
function CustomCheckbox({
  inputLabel,
  checkboxLabel,
  name,
  value,
  onChangeValue,
  valueRequired,
  error,
  errorMessage,
  fontSize,
}: CustomCheckInputProperties) {
  return (
    <div className={`custom-checkbox-wrap ${fontSize}`}>
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div
        className="custom-checkbox-container"
        onClick={(event: React.MouseEvent<HTMLDivElement>) => {
          event.stopPropagation();
          onChangeValue(name, !value);
        }}
        role="presentation">
        <input
          type="checkbox"
          checked={value}
          readOnly
          className="custom-checkbox-input"
        />
        <div className="checkbox-label">{checkboxLabel}</div>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CustomCheckbox.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  error: false,
  errorMessage: '',
  fontSize: 'small',
};

export default React.memo(CustomCheckbox);
